export const UPDATE_FILTER = 'UPDATE_FILTER';
export const RESET_FILTER = 'RESET_FILTER';

export const updateFilter = (filters, isReset = true) => ({
  type: UPDATE_FILTER,
  filters,
  isReset
});

export const resetFilter = () => ({
  type: RESET_FILTER
});
